import { styled } from '@mui/material';
import { drawerWidth, drawerMiniWidth, defaultFont, rightDrawerWidth } from 'assets/jss/styles';
import { includes } from 'ramda';

export const Container = styled('div')(({ theme }) => ({
  ...defaultFont(theme),
  backgroundColor: theme.palette.background.default,
  color: theme.palette.primary.main,
  position: 'relative',
  top: '0',
  height: '100vh',
  '&:after': {
    display: 'table',
    clear: 'both',
    content: '" "'
  }
}));

export const Content = styled('div', {
  shouldForwardProp: prop => !includes(prop, ['drawerMinimized', 'rightSideOpened'])
})(({ theme, drawerMinimized, rightSideOpened }) => ({
  [theme.breakpoints.up('md')]: {
    width: `calc(100% - ${drawerWidth}px)`
  },
  overflow: 'auto',
  overflowX: 'hidden',
  position: 'relative',
  float: 'right',
  maxHeight: '100%',
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflowScrolling: 'touch',
  ...(!drawerMinimized && {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerMiniWidth}px)`
    }
  }),
  ...(rightSideOpened && {
    marginRight: rightDrawerWidth,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${(!drawerMinimized ? drawerMiniWidth : drawerWidth) + rightDrawerWidth}px)`
    }
  })
}));

export const SideButtonsWrapper = styled('div')(() => ({
  position: 'sticky',
  top: 0,
  zIndex: 10
}));
